module.exports = __webpack_public_path__ + "img/realname.8c0aa250.png";